<template>
  <v-layout class="ma-0 pa-0" column>

    <!-- Vuetify -->
    <vue-snotify></vue-snotify>

    <v-row>
        <v-col cols="12" xs="12" sm="12" md="12">
            <v-card width="100%" class="mx-auto" flat>

                <!--Title -->
                <v-card-title class="headline font-weight-regular justify-space-between primary--text">Codes

                    <v-spacer></v-spacer>

                    <!--New Code Generation Buttons-->
                    <v-btn class="mx-2" dark color="primary" @click="accessCodeDialog = true;createCode()" >
                        <v-icon>icons8-access-3</v-icon>
                    </v-btn> 

                </v-card-title>

                <v-divider class="secondary mx-4"></v-divider>

                <!-- Card Content--> 
                <v-card-text class="text-left mt-4">

                    <!--Information-->
                    <span class="grey--text text--darken-1">  Use the search bar below to display the data you are looking for in the table below.</span>

                    <!--Filters-->
                    <v-text-field v-model="search" class="mb-2" append-icon="icons8-search-2" label="Search" single-line hide-details></v-text-field>

                    <!--Data Table--> 
                    <v-data-table :headers="headers" :items="codes" :search="search" item-key="id" single-select>
                    
                        <!--Code-->
                        <template v-slot:[`item.code`]="{ item }">
                            <v-chip class="secondary">{{ item.code }}</v-chip>
                        </template>

                        <!--Used--->
                        <template v-slot:[`item.used`]="{ item }">
                            <v-icon v-if="item.used === true" class="secondary--text">icons8-checked-checkbox</v-icon>
                            <v-icon v-else>icons8-unchecked-checkbox</v-icon>
                        </template>
                        
                        <template v-slot:[`item.createdTimestamp`]="{ item }">
                            <span class="text-capitalize">{{formatDate(item.createdTimestamp)}}</span>
                        </template>

                         <template v-slot:[`item.expirationDate`]="{ item }">
                            <span v-if="item.expirationDate!=''" class="text-capitalize">{{formatDate(item.expirationDate)}}</span>
                        </template>

                        <!--Actions-->
                        <!-- <template v-slot:[`item.actions`]="{ item }">
                            <v-row align="end" justify="end" class="mr-1">
                                <v-icon medium class="mr-2 tableForeground--text font-weight-bold" @click="editItem(item)">icons8-edit</v-icon>
                                <v-icon medium class=" tableForeground--text font-weight-bold" @click="deleteItem(item)">icons8-delete-bin</v-icon>
                            </v-row>
                        </template> -->

                    </v-data-table>

                </v-card-text>
            </v-card>
        </v-col>

        <!--Generation OF new codes-->
        <v-dialog v-model="accessCodeDialog" width="512px" hide-overlay transition="dialog-bottom-transition">

            <v-card flat>
                <v-toolbar dark color="primary">
                    Generate New Activation Code
                    <v-spacer></v-spacer>
                    <v-icon @click="accessCodeDialog = false">mdi-close</v-icon>
                </v-toolbar>

                <div class="py-4 px-4">
                    <span class="text-medium">
                        The new activation code is: <b> {{newGeneratedCode}}</b><br>
                    </span>
                    <span class="text-medium ">
                        <b>Do you wish to save the activation code?</b>
                    </span>
                </div>

                <!--Dialog Actions--> 
                <v-card-actions class="text-center mt-0 pt-0" >
                    <v-row class="ma-0 pa-0" justify="center">
                        <v-col cols="6" class="white--text mt-0 pt-0">
                            <v-btn @click="accessCodeDialog = false;" color="grey lighten-2" block elevation="0">
                                <span class="black--text">No  </span>
                            </v-btn>                
                        </v-col>
                        <v-col cols="6" class="mt-0 pt-0">
                            <v-btn block @click="generateCode()" color="primary" elevation="0" >
                                <span class="white--text"> YES  </span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
  </v-layout>
</template>

<script>
import { Snotify, SnotifyPosition, SnotifyToast } from "vue-snotify";

export default {
  name: "Codes",

    data() {
        return {
            
            accessCode:[],
            accessCodeDialog: false,
            search: "",
            headers: [{ text: "Code", align: "start", filterable: true, value: "code"},
                    { text: "Used", align: "start", filterable: true, value: "used" },
                    { text: "Used By", align: "start", filterable: true, value: "usedBy" },
                    { text: "School", align: "start", filterable: true, value: "schoolName" },
                    { text: "Created Date", align: "start", filterable: true, value: "createdTimestamp" },
                    { text: "Expiration Date", align: "start", filterable: true, value: "expirationDate" }
                   ],

            newGeneratedCode:"",
            codes: [],
            codesForm:{
                id:"",
                code:"",
                createdByID:"",
                createdTimestamp:"",
                createdBy:"",
                schoolName:"",
                expirationDate:"",
                used:false,
                usedBy:"",
                usedById:"",
                usedTimestamp:"",
            },
        };
    },

    computed: {

    },

  methods: {
    createCode(){
        var self=this;
        var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        var result = "",
        rand;
        for (var i = 0; i < 8; i++) {
        rand = Math.floor(Math.random() * chars.length);
        result += chars.charAt(rand);
        }
        result = result.substring(0, 4) + "-" + result.substring(4, result.length);
        this.newGeneratedCode = result;
        return result
    },
   
    generateCode(){
    
        this.codesForm.code = this.newGeneratedCode;
        this.codesForm.createdByID = this.$store.getters.currUser.id;
        this.codesForm.createdTimestamp = this.$moment().toISOString();
        this.codesForm.createdBy = this.$store.getters.currUser.fullName;

        this.$firebase.db
          .collection("codes")
          .doc()
          .set(this.codesForm)
          .then((Result) => {})
          .catch((err) => {
            // console.log(err);
          });
      
      this.$snotify.success("A new activation code: " + this.newGeneratedCode + " has been created");
      this.accessCodeDialog = false;
    },

    formatDate(date) {
      date = this.$moment(date).format("DD MMM YYYY");
      return date;
    },
  },
  created() {
    var self = this;
    this.$firebase.db.collection("codes").onSnapshot((querySnapshot) => {
      self.codes = [];
      var Data = [];
      querySnapshot.forEach((doc) => {
        Data = doc.data();
        Data.id = doc.id;
        self.codes.push(Data);
      });
    });
  },
};
</script>
